/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import MenuIcon from '@mui/icons-material/Menu';
import { IconButton } from '@mui/material';
import { FC } from 'react';

export const HeaderMobileToggleButton: FC<{
	toggleDrawer: (open?: boolean) => () => void;
	open: boolean;
}> = ({ toggleDrawer }) => {
	return (
		<IconButton color="inherit" aria-label="open drawer" onClick={toggleDrawer()} edge="start">
			<MenuIcon />
		</IconButton>
	);
};
